// extracted by mini-css-extract-plugin
module.exports = {"button":"ReviewForm_button__39ZAq","mainColumn":"ReviewForm_mainColumn__2tmOL","containerFlex":"ReviewForm_containerFlex__1yveI","illustration":"ReviewForm_illustration__3BWzK"};